import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import * as ModerationService from '@/services/ModerationService';
import type { ModerationOverrideRequest } from '@/types/moderation';

export const usePendingModerations = () =>
  useQuery({
    queryKey: ['moderation', 'pending'],
    queryFn: () => ModerationService.getPendingModerations(),
    refetchInterval: 30000,
  });

export const useModerationResult = (offerId: number) =>
  useQuery({
    queryKey: ['moderation', offerId],
    queryFn: () => ModerationService.getModerationResult(offerId),
    enabled: offerId > 0,
  });

export const useModerationHistory = (offerId: number) =>
  useQuery({
    queryKey: ['moderation', offerId, 'history'],
    queryFn: () => ModerationService.getModerationHistory(offerId),
    enabled: offerId > 0,
  });

export const useOverrideModeration = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: ModerationOverrideRequest) => ModerationService.overrideModeration(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['moderation'] });
    },
  });
};
